import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import yn from 'yn'

import apiConfiguration from '../utilities/api/apiConfiguration'

// Import activeStep actions
import setActiveStep from './activeStepActions'
import getCookie from '../utilities/session/getCookie'
import tripTeaseHotelReservation from '../utilities/tripTease/tripTeaseHotelReservation'
import accorSecurePaymentForm, { accorSecurePaymentRedirect } from '../utilities/payment/accorSecurePayment'
import accorCompleteDsp2Payment from '../utilities/payment/accorCompleteDsp2Payment'
import {setCartAttemptsCount} from './setUserSession'
import recordDsp2Transaction from './recordDsp2Transaction'

// GA events handler
import triggerCustomGaEvent from '../utilities/analytics/triggerCustomGaEvent'
import generateUuid from '../utilities/api/generateUuid'
import createCart from './createCart'
import fetchTransactionToken from './fetchTransactionToken'
import eraseCookie from '../utilities/session/removeCookie'

export const CREATE_RESERVATION_BEGIN = 'CREATE_RESERVATION_BEGIN'
export const CREATE_RESERVATION_SUCCESS = 'CREATE_RESERVATION_SUCCESS'
export const CREATE_RESERVATION_ERROR = 'CREATE_RESERVATION_ERROR'

export const createReservationBegin = ({
	type: CREATE_RESERVATION_BEGIN
})

export const createReservationSuccess = confirmation => ({
	type: CREATE_RESERVATION_SUCCESS,
	payload: confirmation
})

export const createReservationError = error => ({
	type: CREATE_RESERVATION_ERROR,
	payload: { error }
})

export default function createReservation(renewedSessionId) {
	return (dispatch, getState) => {
		// Begin create reservation set loading true & error false
		dispatch(createReservationBegin)

		const urlData = getState().availabilityData.urlData
		const activeRoom = getState().activeRoomData
		const activeEnhancementData = getState().activeEnhancementData
		const activeGuest = getState().form.guestForm
		const activePayment = getState().form.paymentForm
		const activeTermsConditions = getState().form.termsConditions
		const activeCreditType = getState().activeCreditData.creditType
		const activeStep = getState().activeStepData.activeStep
		const configData = getState().configData.configuration
		const activeCartData = getState().activeCartData
		const cartAttemptsCount = getState().userSessionData.cartAttemptsCount
		const transactionTokenData = getState().transactionTokenData
		const pspSessionId = _.get(transactionTokenData, 'pspSessionId', '')

		const hotelLabels = configData.hotel.labels[0]

		// Mapping card type to Synxis values
		let formattedCardType = ''

		switch (activeCreditType) {
			case 'dankort':
			case 'visa':
				formattedCardType = 'VI'
				break
			case 'mastercard':
				formattedCardType = 'MC'
				break
			case 'maestro':
				formattedCardType = 'SW'
				break
			case 'amex':
				formattedCardType = 'AX'
				break
			case 'diners':
				formattedCardType = 'DN'
				break
			case 'discover':
				formattedCardType = 'DS'
				break
			case 'jcb':
				formattedCardType = 'JC'
				break
			default:
				formattedCardType = 'undefined'
				break
		}

		let reservationEntries = {
			createParameters: []
		}

		// Window.session data for guests / pets
		let flowGuestData = null

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		let activeCartId = null

		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_CART) &&
			activeCartData &&
			activeCartData.cart
		) {
			const currentCart = activeCartData.cart

			for (const cartKey in currentCart) {
				activeCartId = currentCart[cartKey].id
			}
		}

		// Construct reservation data
		for (let roomKey in activeRoom) {
			// Construct enhancements
			let servicesEnhancements = [],
					adultsVal = 1,
					childrenVal = 0,
					childAgesVal,
					consentData = [],
					commentString = '',
					travelAgentCode = '',
					emailConsentLabel = 'I want to receive property and stay notifications',
					smsConsentLabel = 'I consent to receive text notifications',
					dogsVal = null,
					catsVal = null,
					isAccessibleRoom = null,
					promoCodeVal = ''

			// Set by session OR query with fallback
			if (
				flowGuestData &&
				flowGuestData[roomKey].adults >= 0
			) {
				adultsVal = flowGuestData[roomKey].adults
			} else if (urlData.adults) {
				adultsVal = urlData.adults
			}

			// Set by session OR query with fallback
			if (
				flowGuestData &&
				flowGuestData[roomKey].children >= 0
			) {
				childrenVal = flowGuestData[roomKey].children
			} else if (urlData.children) {
				childrenVal = urlData.children
			}

			if (
				flowGuestData &&
				flowGuestData[roomKey].childAges
			) {
				childrenVal = flowGuestData[roomKey].childAges
			} else if (urlData.childAges) {
				childAgesVal = urlData.childAges
			}

			if (urlData.childAges) {
				childAgesVal = urlData.childAges
			}

			// Set iataID
			if (activeGuest.values.travelAgentCode) {
				travelAgentCode = activeGuest.values.travelAgentCode
			}

			// Append guest consents by type to response
			if (
				hotelLabels &&
				hotelLabels.emailOptIn
			) {
				emailConsentLabel = hotelLabels.emailOptIn
			}

			if (
				hotelLabels &&
				hotelLabels.textConsent
			) {
				smsConsentLabel = hotelLabels.textConsent
			}

			if (
				activeGuest.values.emailOptIn &&
				process.env.REACT_APP_COMPONENT_GUEST_FORM_EMAIL_CONSENT === 'default'
			) {
				consentData.push(
					{
						accepted: activeGuest.values.emailOptIn,
						type: 'newsletter',
						wording: emailConsentLabel
					}
				)
			} else if (
				activeTermsConditions.values.emailOptIn &&
				process.env.REACT_APP_COMPONENT_GUEST_FORM_EMAIL_CONSENT === 'terms-conditions'
			) {
				consentData.push(
					{
						accepted: activeTermsConditions.values.emailOptIn,
						type: 'newsletter',
						wording: emailConsentLabel
					}
				)
			}

			if (
				activeGuest.values.textOptIn &&
				process.env.REACT_APP_COMPONENT_GUEST_FORM_SMS_CONSENT === 'default'
			) {
				consentData.push(
					{
						accepted: activeGuest.values.textOptIn,
						type: 'sms',
						wording: smsConsentLabel
					}
				)
			} else if (
				activeTermsConditions.values.textOptIn &&
				process.env.REACT_APP_COMPONENT_GUEST_FORM_SMS_CONSENT === 'terms-conditions'
			) {
				consentData.push(
					{
						accepted: activeTermsConditions.values.textOptIn,
						type: 'sms',
						wording: smsConsentLabel
					}
				)
			}

			// Construct user special requests / comments with a timestamp
			if (activeGuest.values.comments) {
				commentString = moment().format("dddd, MMMM Do YYYY, h:mm:ss a") + ' - ' + activeGuest.values.comments
			}

			if(
				flowGuestData &&
				flowGuestData[roomKey].dogs
			) {
				dogsVal = flowGuestData[roomKey].dogs
			} else if (urlData.dogs) {
				dogsVal = urlData.dogs
			}

			if(
				flowGuestData &&
				flowGuestData[roomKey].cats
			) {
				catsVal = flowGuestData[roomKey].cats
			} else if (urlData.cats) {
				catsVal = urlData.cats
			}

			if (
				urlData.accessible &&
				urlData.accessible === 'true'
			) {
				isAccessibleRoom = true
			}

			for (let enhancementKeys in activeEnhancementData) {
				if (Number(activeEnhancementData[enhancementKeys].roomGroup) === Number(roomKey) && activeEnhancementData[enhancementKeys].roomType === activeRoom[roomKey][0][0].roomTypeCode) {

					// effective date and fallback
					let effectiveDate = urlData.startDate

					if (_.get(activeEnhancementData[enhancementKeys], 'enhancementApiData.price[0].effectiveDate')) {
						effectiveDate = activeEnhancementData[enhancementKeys].enhancementApiData.price[0].effectiveDate
					}

					// Format individual services
					let serviceEnhancement = {
							serviceInventoryCode: activeEnhancementData[enhancementKeys].enhancementApiData.serviceInventoryCode,
							dateStart: effectiveDate,
							adults: adultsVal,
							children: childrenVal
						}

					// Combine formatted services for reservationEntry
					servicesEnhancements.push(serviceEnhancement)
				}
			}

			let itineraryBookingVal = false

			if (
				urlData.itineraryBooking &&
				urlData.itineraryBooking === 'true'
			) {
				itineraryBookingVal = true
			}

			// Set a promo code value if set in url and matches availability data key value ratePlanId
			if (
				urlData &&
				urlData.promoCode &&
				activeRoom &&
				activeRoom[roomKey] &&
				_.get(activeRoom[roomKey], '[1][0].viewExtensions.ratePlanId') &&
				String(urlData.promoCode) === String(activeRoom[roomKey][1][0].viewExtensions.ratePlanId)
			) {
				promoCodeVal = activeRoom[roomKey][1][0].viewExtensions.ratePlanId
			} else {
				promoCodeVal = activeRoom[roomKey][1][0].ratePlanCode
			}

			let stateProvValue = ''

			if (
				_.get(activeGuest, 'values.stateProv') &&
				activeGuest.values.stateProv !== 0
			) {
				stateProvValue = activeGuest.values.stateProv
			}

			const currentLanguage = _.get(urlData, 'primaryLangId', '')

			let reservationEntry = {
				cartId: activeCartId,
				roomStays: {
					hotelCode: urlData.hotelCode,
					chainCode: configData.hotel.options.chainCode,
					dateStart: urlData.startDate,
					dateEnd: urlData.endDate,
					ratePlanCode: activeRoom[roomKey][1][0].ratePlanCode,
					promoCode: promoCodeVal,
					adults: adultsVal,
					children: childrenVal,
					childAges: childAgesVal,
					roomTypes: {
						roomTypeCode: activeRoom[roomKey][0][0].roomTypeCode,
						numberOfUnits: 1
					}
				},
				resGuests: {
					primary: true,
					namePrefix: activeGuest.values.prefix,
					givenName: activeGuest.values.firstName,
					surName: activeGuest.values.lastName,
					countryAccessCode: 1,
					telephone: activeGuest.values.phone,
					address1: activeGuest.values.address1,
					address2: activeGuest.values.address2,
					city: activeGuest.values.city,
					stateProv: stateProvValue,
					email: activeGuest.values.email,
					country: activeGuest.values.country,
					postal: _.get(activePayment, 'values.postalCode', ''),
					primaryLangId: currentLanguage,
				},
				comments: commentString,
				ssr: {
					cats: catsVal,
					dogs: dogsVal,
					preCheckin: null,
					accessible: isAccessibleRoom
				},
				consents: consentData,
				paymentCard: {
					cardNumber: activePayment.values.creditCard.replace(/\s/g, ''),
					cardCode: formattedCardType,
					seriesCode: activePayment.values.cvv,
					expireDate: activePayment.values.expirationMonth + '/' + activePayment.values.expirationYear,
					cardHolderName: activeGuest.values.firstName + ' ' + activeGuest.values.lastName
				},
				psd2:{
					transactionToken: _.get(transactionTokenData, 'tokens.transactionToken', ''),
					transactionReferenceId: _.get(transactionTokenData, 'tokens.transactionReferenceId', ''),
					pspSessionId: pspSessionId,
					deviceFingerPrint: _.get(transactionTokenData, 'tokens.fingerPrintId', '')
				},
				services: servicesEnhancements,
				iataId: travelAgentCode,
				itineraryBooking: itineraryBookingVal
			}

			// Append activeRooms to reservationEntries
			reservationEntries['createParameters'].push(reservationEntry)
		}

		let hotelProvider = 0,
				sessionId = null,
				currentClientId = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			currentClientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		if (
			urlData &&
			urlData.hotelProvider
		) {
			hotelProvider = urlData.hotelProvider
		}

		if (renewedSessionId) {
			sessionId = renewedSessionId
		} else if (
			getCookie('flowSessionId') &&
			getCookie('flowSessionId') !== ''
		) {
			sessionId = getCookie('flowSessionId')
		}

		// URL Params
		let urlParams = {
			hotelProvider: hotelProvider,
			sessionId: sessionId,
			clientId: currentClientId
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		let apiBase = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/hotel/reservation?'

		// Combine API URL & formatted urlParams
		const createResEndPoint = apiBase + fetchQuery.toString()

		// Initial reservation request
		axios.post(createResEndPoint, JSON.stringify(reservationEntries), apiConfiguration())
		.then((response) => {

			if(
				_.isEmpty(response.data.errors) &&
				!_.isEmpty(response.data['hydra:member'])
			) {

				for (const resKey in response.data['hydra:member']) {
					const currentReservation = response.data['hydra:member'][resKey]

					// Dispatch initial GA events
					const gaConfirmationData = {
						roomStays: currentReservation.roomStays,
						services: currentReservation.services,
						uniqueId: currentReservation.uniqueId,
						resGlobalInfo: currentReservation.resGlobalInfo,
						viewExtensions: currentReservation.viewExtensions
					}

					triggerCustomGaEvent('analytics-reservationConfirmation', gaConfirmationData)
				}

				// TripTease reservation event
				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_TRIPTEASE) &&
					urlData &&
					response &&
					response.data &&
					response.data['hydra:member'] &&
					response.data['hydra:member'][0]
				) {
					tripTeaseHotelReservation(response.data['hydra:member'][0], urlData)
				}
				const reservationData = response.data['hydra:member']

				let isSuccessfulDsp2Transaction = false
				const bookingId = _.get(reservationData, '[0]viewExtensions.payment.bookingId', null)
				const dsp2Payload = _.get(reservationData, '[0]viewExtensions.payment.psd2Payload', null)
				const dsp2TransactionId = _.get(reservationData, '[0].viewExtensions.payment.psd2PspTransactionId', null)
				const dsp2Url = _.get(reservationData, '[0].viewExtensions.payment.psd2Url', null)

				if (
					bookingId &&
					dsp2Payload &&
					dsp2TransactionId &&
					dsp2Url
				) {
					isSuccessfulDsp2Transaction = true
				}

				function handleNextstep() {
					dispatch(setActiveStep(activeStep + 1))
				}

				function handleDsp2ApiError(errorMessage) {
					try {
						throw new Error(errorMessage)
					} catch(e) {
						dispatch(createReservationError(e))
					}
				}

				function handleSuccessfulReservation() {
					dispatch(createReservationSuccess(reservationData))
				}

				function handleDsp2TransactionSuccess(bookingId, pspTransactionToken, handleDsp2ApiError) {
					dispatch(recordDsp2Transaction(bookingId, pspTransactionToken, handleDsp2ApiError))
				}

				if (
					process.env.REACT_APP_COMPONENT_DSP2_PROVIDER === 'accor' &&
					isSuccessfulDsp2Transaction
				) {
					accorCompleteDsp2Payment(
						activePayment.values.creditCard.replace(/\s/g, ''),
						dsp2Url,
						dsp2Payload,
						dsp2TransactionId,
						bookingId,
						handleSuccessfulReservation,
						handleDsp2TransactionSuccess,
						handleDsp2ApiError,
						hotelLabels
					)
				} else if (yn(process.env.REACT_APP_COMPONENT_ENABLE_3DS)) {
					const redirectForm = _.get(reservationData, '[0].viewExtensions.payment.responseBody', null)
					const redirectUrl = _.get(reservationData, '[0].viewExtensions.payment.paymentProviderRedirectUrl', null)

					if (
						redirectForm &&
						process.env.REACT_APP_COMPONENT_3DS_PROVIDER === 'accor'
					) {
						accorSecurePaymentForm(redirectForm, reservationData, urlData, sessionId)
					} else if (
						!redirectForm &&
						redirectUrl &&
						process.env.REACT_APP_COMPONENT_3DS_PROVIDER === 'accor'
					) {
						accorSecurePaymentRedirect(redirectUrl, reservationData, urlData, sessionId)
					} else {
						handleSuccessfulReservation()
						handleNextstep()
					}
				} else {
					handleSuccessfulReservation()
					handleNextstep()
				}

				if (process.env.REACT_APP_COMPONENT_3DS_PROVIDER !== 'accor') {
					// reset session ID for future bookings on successful reservations
					eraseCookie('flowSessionId')
				}
			} else {
				dispatch(createReservationError(response.data.errors[0].shortText))
			}
		})
		.catch(error => {
			const errorStatusCode = _.get(error, 'response.status', null)

			if (
				yn(process.env.REACT_APP_COMPONENT_CART_RENEWAL) &&
				Number(errorStatusCode) === 422 &&
				cartAttemptsCount < Number(process.env.REACT_APP_COMPONENT_CART_RENEWAL_LIMIT)
			) {
				dispatch(setCartAttemptsCount(Number(cartAttemptsCount) + 1))
				setTimeout(() => {
					let renewedSessionId = `${sessionId}-${generateUuid()}`
					dispatch(createCart(renewedSessionId))
				}, 1500)
			} else if (
				Number(errorStatusCode) === 402 &&
				cartAttemptsCount < Number(process.env.REACT_APP_COMPONENT_BOOKING_RENEWAL_LIMIT)
			) {
				dispatch(setCartAttemptsCount(Number(cartAttemptsCount) + 1))

				setTimeout(() => {
					dispatch(fetchTransactionToken())
				}, 1500)
			} else {
				dispatch(createReservationError(error))
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/actions/createReservation.js